import { Trash2Icon } from 'lucide-react'

import { Button, SectionHeading } from '@/components/ui'
import { useDialogActions } from '@/stores'
import { useStatements } from '../../hooks'
import { DeleteDuplicatePagesDialog } from '../dialogs/DeleteDuplicatePagesDialog'
import { Tally } from '../Tally'
import { DuplicateGroupCard } from './DuplicateGroupCard'
import { duplicatePageGroups } from './helpers'

// Repeated page ranges the detector found across the project's files, with per-copy and bulk
// delete. Renders nothing when there are no repeats. The original copy of each repeat is always kept.
export function DuplicatePagesOverview() {
  const { openDialog } = useDialogActions()
  const groups = duplicatePageGroups(useStatements())

  if (groups.length === 0) return null

  return (
    <div className="space-y-3">
      <SectionHeading
        className="flex-wrap"
        title="Repeated pages"
        description="These page ranges repeat an earlier range, in the same file or in a re-uploaded copy. Compare a copy against the original, then delete the ones you do not need."
        actions={
          <Button
            theme="outline"
            size="sm"
            className="cursor-pointer text-red-600 hover:bg-red-50 hover:text-red-700"
            onClick={() => openDialog(DeleteDuplicatePagesDialog.id, groups)}
          >
            <Trash2Icon />
            Delete all ({groups.length})
          </Button>
        }
      />

      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 rounded-lg border bg-white px-4 py-2.5 text-sm">
        <Tally
          label={groups.length === 1 ? 'repeated range' : 'repeated ranges'}
          count={groups.length}
          dotClassName="bg-amber-500"
        />
      </div>

      <div className="space-y-3">
        {groups.map((group) => (
          <DuplicateGroupCard key={group.duplicate.id} group={group} />
        ))}
      </div>
    </div>
  )
}
